import type React from "react";

import { ErrorBanner } from "components/Error/ErrorBanner";
import GetAssetRegisterEntitiesCombination from "core/action/GetAssetRegisterEntitiesCombination";
import { useParams } from "react-router-dom";
import { OneCardPage } from "../../../components/utils/OneCardPage";
import { useRequiredSelectedCompanyId } from "../../../hooks/useCompany";
import { useSelectedSchemeId } from "../../../hooks/useScheme";
import { statusEnum } from "../../../kubb";
import { NotFoundErrorForEntity } from "../../../model/error";
import AssetPositionDisplay from "./AssetPositionDisplay";

export default function AssetPositionHomepage(): React.ReactElement {
  const company_id = useRequiredSelectedCompanyId();
  const scheme_id = useSelectedSchemeId();
  const { asset_position_id } = useParams();

  if (asset_position_id === undefined) {
    throw new Error("asset_position_id must be set.");
  }

  return (
    <GetAssetRegisterEntitiesCombination
      asset_position_id={asset_position_id}
      scheme_id={scheme_id}
      company_id={company_id}
      status={[statusEnum.ACTIVE, statusEnum.DELETED]}
      error={({ error }) => (
        <OneCardPage
          headerTitle={"Asset Position Detail"}
          breadcrumbs={[{ name: "Error" }]}
          setPageTitle={() => "Asset Position: Error"}
        >
          <ErrorBanner error={error} />
        </OneCardPage>
      )}
      placeholder={() => (
        <OneCardPage
          headerTitle={"Asset Position Detail"}
          loading={true}
          breadcrumbs={[{ name: "Loading" }]}
          setPageTitle={() => "Asset Position: Loading"}
        />
      )}
    >
      {({ assetPosition, ...rest }) =>
        assetPosition ? (
          <AssetPositionDisplay assetPosition={assetPosition} {...rest} />
        ) : (
          <OneCardPage
            headerTitle={"Asset Position Detail"}
            breadcrumbs={[{ name: "Not Found" }]}
            setPageTitle={() => "Asset Position: Not Found"}
          >
            <ErrorBanner
              error={NotFoundErrorForEntity(
                "Asset Position",
                asset_position_id,
              )}
            />
          </OneCardPage>
        )
      }
    </GetAssetRegisterEntitiesCombination>
  );
}
